/* SILA product-page price and recently-viewed behavior. */

(() => {
  const money = (cents) => `LE ${Math.round(Number(cents || 0) / 100).toLocaleString('en-US')}`;

  const updateAtc = (variant, sectionId) => {
    if (!variant || !sectionId) return;
    const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const copy = button?.querySelector('[data-sila-atc-copy]');
    if (!button || !copy) return;
    if (!variant.available || button.disabled) return;
    const label = copy.dataset.baseLabel || 'Add to cart';
    copy.textContent = `${label}  ${money(variant.price)}`;
  };

  const subscribeToVariant = () => {
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.variantChange) return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      updateAtc(event?.data?.variant, event?.data?.sectionId);
    });
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[char]);

  const renderRecentlyViewed = (root) => {
    if (!root || root.dataset.silaReady === 'true') return;
    root.dataset.silaReady = 'true';

    const storageKey = 'sila-recently-viewed-v1';
    const current = {
      handle: root.dataset.currentHandle,
      title: root.dataset.currentTitle,
      url: root.dataset.currentUrl,
      image: root.dataset.currentImage,
      price: Number(root.dataset.currentPrice || 0),
      compare: Number(root.dataset.currentCompare || 0),
      available: root.dataset.currentAvailable === 'true'
    };
    const limit = Number(root.dataset.limit || 4);
    let items = [];
    try { items = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_) { items = []; }

    const previous = items.filter((item) => item?.handle && item.handle !== current.handle).slice(0, limit);
    const grid = root.querySelector('[data-sila-recent-grid]');
    if (grid && previous.length) {
      grid.innerHTML = previous.map((item) => {
        const onSale = Number(item.compare) > Number(item.price);
        return `<li><article class="sila-product-card">
          <a class="sila-product-card__media" href="${escapeHtml(item.url)}">
            ${item.image ? `<img class="sila-product-card__image sila-product-card__image--primary" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async">` : ''}
            ${item.available === false ? '<span class="sila-product-card__badge">Sold out</span>' : ''}
          </a>
          <div class="sila-product-card__info">
            <h3 class="sila-product-card__title"><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h3>
            <div class="sila-card-price${onSale ? ' sila-card-price--sale' : ''}"><span class="sila-card-price__current">${money(item.price)}</span>${onSale ? `<s class="sila-card-price__compare">${money(item.compare)}</s>` : ''}</div>
          </div>
        </article></li>`;
      }).join('');
      root.hidden = false;
    }

    if (current.handle) {
      const next = [current, ...items.filter((item) => item?.handle !== current.handle)].slice(0, 12);
      try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch (_) {}
    }
  };

  const init = () => {
    subscribeToVariant();
    document.querySelectorAll('[data-sila-recently-viewed]').forEach(renderRecentlyViewed);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-sila-recently-viewed]').forEach(renderRecentlyViewed);
  });
})();
